export default __webpack_public_path__ + "static/icon-f9cb2f42cdd3a5aeb68dd370b2067411.svg";